<template>
    <div :class="stepWrapperClasses" :key="step">
        <div class="step-body">
            <div class="row">
                <div class="col-lg-7">
                    <h5 class="step-field-heading"><span class="las back" v-if="isNotFirstStep" @click="back()">
                    <img src="../../assets/arrow_back-24px.svg" >
                    </span>
                    <span class="step-field-heading-text">Select Date &amp; Time</span></h5>
                </div>
                <div class="col-lg-5">
                    <div class="date-filter">
                        <div class="date-filter-arrows">
                            <div @click="prevDate"
                            :class="previousDayArrowClass">
                                <img src="../../assets/keyboard_arrow_left-24px.svg" >
                            </div>
                            <div @click="nextDate" class="date-filter-arrows-right">
                                <img src="../../assets/keyboard_arrow_right-24px.svg" >
                            </div>
                        </div>
                        <datepicker v-if="isService"
                            @input="reloadDatesAndTimes"
                            v-model="date"
                            :format="customFormat"
                            :calendar-button="true"
                            :calendar-button-icon="icon"
                            :disabledDates="disabledDates"
                        ></datepicker>
                        <datepicker v-else
                            @input="reloadDatesAndTimes"
                            v-model="date"
                            :format="customFormat"
                            :calendar-button="true"
                            :calendar-button-icon="icon"
                            :minimum-view="'month'"
                            :maximum-view="'year'"
                            :disabledDates="disabledDates"
                        ></datepicker>
                    </div>
                </div>
            </div>
            <div v-if="datesAndTimesLoaded" class="step-fields-body">
                <ul class="list-unstyled dates-and-times-wrapper">
                    <date-and-time-row
                    v-for="item in stepData.schedulingDateAndTime"
                    :key="item.id"
                    :value="value"
                    :item="item"
                    v-on:filled-out="addDateAndTimeBookingDetails($event)"></date-and-time-row>
                </ul>
            </div>
            <div v-else-if="datesAndTimesEmpty" class="alert alert-primary">
                Sorry! There are no available times for <strong>{{bookingDetails.service.name}}</strong> on this day.
                Please choose another day using the calendar above.
            </div>
            <div v-else class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapMutations, mapState, mapGetters } from 'vuex';
  import axios from 'axios';
  import moment from 'moment';
  import Datepicker from 'vuejs-datepicker';
  import DateAndTimeRow from './SchedulingDateAndTimeRow'
  import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [schedulingMixin],
    data() {
        return {
            date: '',
            disabledDates: {
              to: new Date(Date.now() - 8640000)
            },
            cancelToken: ''
        }
    },
    props: {
      field: {},
      details: {},
      value: '',
      index: '',
    },
    methods: {
        ...mapMutations('scheduling', [
          'addBookingDetails',
          'nextStep',
          'prevStep',
          'setGlobalDateForDatePicker',
          'setStepData',// referenced in the mixin
        ]),
        back() {
            this.prevStep();
            this.cancelToken.cancel();
        },
        nextDate() {
            let denom = this.isService ? 'days' : 'month';
            this.date = moment(this.date).add(1, denom).toDate();
            this.reloadDatesAndTimes();
        },
        prevDate() {
            if (this.previousIsValid) {
                let denom = this.isService ? 'days' : 'month';
                this.date = moment(this.date).subtract(1, denom).toDate();
                this.reloadDatesAndTimes();
            }
        },
        addDateAndTimeBookingDetails(value) {
            let dateAndTime = this.getDateAndTimeById(value);
            let oldDateAndTime = this.bookingDetails.schedulingDateAndTime;
            this.addBookingDetails({
                'type' : 'schedulingDateAndTime',
                'details' : dateAndTime
            });
            this.nextStep();
            if (!oldDateAndTime || oldDateAndTime.id != dateAndTime.id) {
                this.resetStepData();
            }
            this.$emit('filled-out',dateAndTime);
        },
        getDateAndTimeById(id) {
            let dateAndTime = this.stepData.schedulingDateAndTime.filter(dateAndTime => dateAndTime.id == id);
            if (dateAndTime[0]) {
                return dateAndTime[0];
            } else {
                return {};
            }
        },
        customFormat(date) {
            if (this.isService) {
                return moment(date).format('ddd - MMM D, YYYY');
            } else {
                return moment(date).format('MMM YYYY');
            }
        },
        reloadDatesAndTimes() {
            this.resetStepData();
            this.loadDatesAndTimes();
        },
        async loadDatesAndTimes(token) {
            this.setGlobalDateForDatePicker(this.date);
            var response;
            var params = {
                params: this.getParams(),
                cancelToken: token
            };
            response = await axios.get(`${this.domain}/forms/api/v1/forms/${this.formId}/integrations/scheduling/api/date-and-times`, params);
            this.setCurrentStepData(response.data);
        },
        getParams() {
            if (this.bookingDetails.service && this.bookingDetails.service.id) {
                return {
                    service: this.bookingDetails.service && this.bookingDetails.service.id ? this.bookingDetails.service.id : null,
                    // service: 16,
                    type: 'serviceEvents', // TODO need away of determing type
                    day: moment(this.date).format('YYYY-MM-D'),
                    shortTimeZone: this.getTimezone()
                };
            } else {
                return {
                    event: this.bookingDetails.event && this.bookingDetails.event.id ? this.bookingDetails.event.id : null,
                    type: 'events',
                    startDateTime: moment(this.date).format('YYYY-MM-D hh:mm'),
                    endDateTime: moment(this.date).endOf('month').format('YYYY-MM-D hh:mm'),
                    shortTimeZone: this.getTimezone()
                };
            }
        },
        getTimezone() {
            // Get a specific point in time (here, the current date/time):
            const d = new Date();

            // Get a DateTimeFormat object for the user's current culture (via undefined)
            // Ask specifically for the long-form of the time zone name in the options
            const dtf = Intl.DateTimeFormat(undefined, {timeZoneName:'short'});

            // Format the date to parts, and pull out the value of the time zone name
            return dtf.formatToParts(d).find((part) => part.type == 'timeZoneName').value;
        }
    },
    created() {
        if (!this.globalDateForDatePicker) {
            if (this.nextEvent) {
                this.date = new Date(this.nextEvent.replace(' ', 'T'));
            } else {
                this.date = new Date();
            }
            this.setGlobalDateForDatePicker(this.date);
        } else {
            this.date = this.globalDateForDatePicker;
        }
        if (!this.datesAndTimesLoaded) {
            this.cancelToken = axios.CancelToken.source();
            this.loadDatesAndTimes(this.cancelToken.token);
        }
    },
    computed: {
        ...mapGetters('form', [
          'fields',
          'domain'
        ]),
        ...mapGetters('scheduling', [
            'nextEvent'
        ]),
        ...mapState('form', { form: 'form', formId: 'formId' }),
        ...mapState('scheduling', {
            step: 'step',
            globalDateForDatePicker: 'globalDateForDatePicker',
            stepData: 'stepData',
            bookingDetails:'bookingDetails',
        }),
        datesAndTimesLoaded() {
            return this.stepData.schedulingDateAndTime !== '' && !this.datesAndTimesEmpty;
        },
        datesAndTimesEmpty() {
            return Array.isArray(this.stepData.schedulingDateAndTime) && this.stepData.schedulingDateAndTime.length==0;
        },
        icon() {
            return 'calendar';
        },
        isService() {
            return !this.form.integrationFormType || this.form.integrationFormType == 'service';
        },
        previousIsValid() {
            let d = this.date;
            let denom = this.isService ? 'days' : 'month';
            d = moment(d).subtract(1, denom).toDate();
            d.setHours(23);
            d.setMinutes(59);
            d.setSeconds(59);
            return d.getTime() >= Date.now();
        },
        previousDayArrowClass() {
            return {
                'date-filter-arrows-left': true,
                'disabled': !this.previousIsValid
            };
        }
    },
    components: {
        DateAndTimeRow,
        Datepicker
    }
  };
</script>
<style>
.step-field .vdp-datepicker {
    float:right;
}
.date-filter .vdp-datepicker > div > input,.vdp-datepicker > div > input:focus {
    border:0;
    outline:0;
    padding:0;
    padding-right:10px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.19;
    letter-spacing: normal;
    text-align: right;
    color: #24282f;
    height:25px;
    width:180px;
    text-align:right;
    margin-top:0;
}
.date-filter-arrows {
    float: right;
    margin-left:10px;
    position: relative;
    z-index: 999999;
}
.date-filter .vdp-datepicker .la-calendar {
    font-size: 24px
}
.date-filter .vdp-datepicker__calendar-button {
    float: right;
}
.date-filter-arrows > div {
    display:inline-block;
    cursor:pointer;
}
.date-filter-arrows > div.disabled {
    cursor: not-allowed;
}
.date-filter-arrows > div.date-filter-arrows-left {
    padding-right:5px;
}
.date-filter-arrows > div.date-filter-arrows-right {
    padding-left:5px;
}
.calendar {
    display: inline-block;
    width: 24px;
    height:24px;
    background: transparent url(../../assets/calendar_today-24px.svg) no-repeat;
}
.vdp-datepicker__calendar-button {
    width: 18px;
    height:18px;
    margin-top:2px;
}
@media only screen and (max-width: 991px) {
    .date-filter {
        margin-bottom: 20px;
    }
    .date-filter::after {
      content: "";
      clear: both;
      display: table;
    }
    .step-field .vdp-datepicker {
        float: none;
    }
    .date-filter .vdp-datepicker > div > input, .vdp-datepicker > div > input:focus {
        text-align: left;
    }
    .date-filter .vdp-datepicker > div {
        position: relative;
    }
    .date-filter .vdp-datepicker > div > .vdp-datepicker__calendar-button {
        position: absolute;
        top: 0;
        left: 155px;
    }
    .event-scheduling-form .date-filter .vdp-datepicker > div > .vdp-datepicker__calendar-button {
        left:80px;
    }
}
</style>
